import React from "react";
import Table from "../../../../../../common/element/Table";
import moment from "moment";

const { Tr, Th, Td, THead, TBody } = Table;

const UnpaidRenewalsList = ({ rows = [] }) => {
  const formatDate = (value) =>
    value ? moment(value).format("DD/MM/YYYY") : "-";

  const formatCurrency = (amount, currency) => {
    if (amount == null) {
      return "-";
    }
    const parsed = Number(amount);
    if (Number.isNaN(parsed)) {
      return amount;
    }
    return `${currency || ""}${currency ? " " : ""}${parsed.toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`.trim();
  };

  if (!rows.length) {
    return (
      <div className="border border-gray-200 rounded-lg p-6 text-center text-sm text-gray-500">
        No unpaid renewals found for the selected criteria.
      </div>
    );
  }

  return (
    <div className="overflow-hidden border rounded-lg border-gray-200">
      <Table>
        <THead>
          <Tr>
            <Th>Provider</Th>
            <Th>Provider type</Th>
            <Th>Renewal due</Th>
            <Th>Last contacted</Th>
            <Th>Outstanding amount</Th>
            <Th>Licence seats</Th>
            <Th>Worker seats</Th>
            <Th>Assignment seats</Th>
          </Tr>
        </THead>
        <TBody>
          {rows.map((row, index) => (
            <Tr key={row?.sub_invoice_id ?? row?.invoice_id ?? index}>
              <Td>{row?.provider_trading_name ?? "-"}</Td>
              <Td>{row?.provider_type_name ?? "-"}</Td>
              <Td>
                {formatDate(
                  row?.upcoming_invoice_due_date ?? row?.next_renewal_date
                )}
              </Td>
              <Td>{formatDate(row?.last_contacted_on)}</Td>
              <Td>{formatCurrency(row?.amount_due ?? row?.amount, row?.currency)}</Td>
              <Td>{row?.licence_seats ?? "-"}</Td>
              <Td>{row?.worker_seats ?? "-"}</Td>
              <Td>{row?.assignment_seats ?? "-"}</Td>
            </Tr>
          ))}
        </TBody>
      </Table>
    </div>
  );
};

export default UnpaidRenewalsList;
